// extracted by mini-css-extract-plugin
module.exports = {"root":"NoResults__root--2Kqf7","bounce":"NoResults__bounce--2ekOf"};